import React from "react";
import { Grid } from '@mui/material';
import { Select } from "../../../../componentsv2/Select";

export default function SelectSetor({
  onChange,
  value,
  disabled = false,
  required = false,
  todas = true,
}) {
  const options = ["Em Andamento", "Em Aberto", "Finalizado"];
  todas && options.unshift("Todas");
  return (
    <>
      <Grid container spacing={1} justify="center" alignItems="stretch">
        <Grid item xs={12}>
          <Select
            required={required}
            disabled={disabled}
            onChange={onChange}
            value={value}
            label="Situação"
            variant="standard"
            arrayOptions={options}
          />
        </Grid>
      </Grid>
    </>
  );
}
